import styled from "styled-components";
import FileIcon from "./FileIcon";
import { Visibility } from "@material-ui/icons";

export const Container = styled.div`
  .file {
    margin-top: 10px;
    display: grid;
    grid-template-columns: 25% 50% 25%;
    padding: 1rem;
    border-radius: 0.6rem;
    background-color: ${({ from }) =>
      from == "customer" ? "#e4e4e4" : "#afd493"} !important;
  }

  .file > .circle-container {
    display: flex;
    justify-content: flex-end;
    background-color: transparent !important;
  }

  .file > .circle-container > .circle {
    display: flex;
    align-items: center;
    justify-self: center;
    justify-content: center;

    width: 100%;
    max-width: 3.4rem;
    height: 100%;

    border: solid;
    border-width: 1px;
    border-radius: 50%;

    color: rgba(var(--message-file-icon-border), 0.5);
  }
`;

export const Anchor = styled.a`
  text-decoration: none;
`;

export const Icon = styled(FileIcon)``;

export const NameArchive = styled.p`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ContentIcon = styled.div``;

export const SpanIcon = styled.span``;

export const IconType = styled(Visibility)``;
